import React, { useState, useContext, useEffect, useLayoutEffect } from 'react';
import { PageContext } from '../../../lib/PageProvider';
import { RateTierRuleGridStateful } from "./RateTierRuleGridStateful"
import { RateTierRuleFormDialog } from './RateTierRuleFormDialog';
import { mutateUrls } from "../../../lib/useGenericSWR";
import { useSWRConfig } from "swr";
import { EnsureUser } from '../../auth/EnsureUser';
import { UcToolbar } from '../../common/UcToolbar';
import { useHasPermission } from 'components/auth/PermissionApiEndpoint';
import AddIcon from '@mui/icons-material/Add';
import { getRateTierRulesDefaultItem } from './RateTierRuleAPIEndpoints';
import { useTranslation } from "react-i18next";
import { useEnums } from 'components/auth/PermissionApiEndpoint';
import { enumFormatter } from 'lib/EnumFormatter';
import { COLOR_PICKER_OPTIONS } from '../../common/Common.constants'

export const RateTierRuleListPage = (props) => {
    const { t } = useTranslation();
    const rateChargeId = props.rateChargeId;
    const rateChargeType = props.rateChargeType;
    const rateChargeTypeEnums = useEnums("RateChargeType");
    const rateChargeTypeDisplay = enumFormatter(rateChargeTypeEnums, rateChargeType);
    const [editDialog, setEditDialog] = useState({ open: false, delete: false });
    const [selectedItem, setSelectedItem] = useState(null);
    const [pageState, pageDispatch] = useContext(PageContext);
    const existingItems = props.existingItems;

    const [reMutateUrls, setReMutateUrls] = useState(false);
    const swrConfig = useSWRConfig();

    const closeHandler = () => {
        setEditDialog({ open: false, itemToEdit: editDialog.dataItem, existingItems: editDialog.existingItems });
    }

    const saveHandler = () => {
        closeHandler();
        // Also, remutate
        setReMutateUrls(true);
    }

    const openDialog = (dataItem) => {
        if (!dataItem) {
            return;
        }
        if (!dataItem.formIteration) {
            dataItem.formIteration = "edit" + dataItem.id;
        }
        setEditDialog({ open: true, itemToEdit: dataItem, delete: false, existingItems: existingItems });
    }

    const deleteDialog = (dataItem) => {
        if (!dataItem) {
            return;
        }
        if (!dataItem.formIteration) {
            dataItem.formIteration = "delete" + dataItem.id;
        }
        setEditDialog({ open: true, itemToEdit: dataItem, delete: true, setDefault: false });
    }

    const createItem = () => {
        openDialog(getRateTierRulesDefaultItem(rateChargeId));
    }

    const editItem = (item) => {
        openDialog(item);
    }

    const deleteItem = (item) => {
        deleteDialog(item);
    }

    const actions = [
        {
            icon: <AddIcon />,
            title: t('Add {{rateChargeTypeDisplay}} Rule', {rateChargeTypeDisplay: rateChargeTypeDisplay}),
            toolTip: t('Add {{rateChargeTypeDisplay}} Rule', {rateChargeTypeDisplay: rateChargeTypeDisplay}),
            onClick: () => { createItem(); },
            isHidden: !useHasPermission("RateTierRule:Modify"),
            isDisabled: existingItems?.length - 1 >= COLOR_PICKER_OPTIONS.length
        }
    ];

    useLayoutEffect(() => {
        if (reMutateUrls) {
            mutateUrls(swrConfig);
            setReMutateUrls(false);
        }
    }, [reMutateUrls, swrConfig]);

    useEffect(() => {
        pageDispatch({
            header: `Rate ${rateChargeTypeDisplay} Rule`,
        });
    }, [pageState.header, selectedItem, pageDispatch, rateChargeTypeDisplay]);

    console.log("rateTierRuleListPage - Loaded");
    return (
        <div className="rateTierRuleListPage">
            <EnsureUser permissions={["RateTierRule:Read"]}>
                <UcToolbar actions={actions} />
                <RateTierRuleFormDialog
                    open={editDialog.open}
                    delete={editDialog.delete}
                    itemToEdit={editDialog.itemToEdit}
                    existingItems={existingItems}
                    rateChargeType={rateChargeType}
                    rateChargeTypeDisplay={rateChargeTypeDisplay}
                    onCancel={closeHandler}
                    onSave={saveHandler}
                />
                {!reMutateUrls &&
                    <RateTierRuleGridStateful
                        onEditItem={editItem}
                        onDeleteItem={deleteItem}
                        rateChargeId={rateChargeId}
                        onSelected={(selectedDataItem) => {
                            setSelectedItem({ ...selectedDataItem });
                        }} />
                }

            </EnsureUser>
        </div>
    );
};